import { useSelector } from 'react-redux';
import { getIsHeaderBannerHidden } from 'src/store/headerBanner/selectors';
import { isSSR } from 'src/helpers/ssr';

const useHeaderBannerOffset = () => {
  const isHeaderBannerShown = !useSelector(getIsHeaderBannerHidden);

  const hasHeaderBanner = Boolean(isSSR ? undefined : isHeaderBannerShown);

  return hasHeaderBanner ? 60 : 0;
};

export default useHeaderBannerOffset;
